<template>
<div>
  <div class="wrapper" @click="$emit('wishShareGuide-confirm')">
      <!-- <div class="content">
              狼堡信号不太好！小狼人再分享一次哦！!
          </div>
      <div class="button-wrapper">
          <img src="../../assets/modal/confirm7.png" alt="" class="button"  @click="$emit('wishShareFail-cofirm')">
      </div> -->
      <img src="../../assets/modal/tip.png" alt="" class="tip">
  </div>
</div>
</template>

<script>
export default {
    name: 'wishShareGuide',
    data() {
        return {
        }
    },
   
    methods: {
       
    }
}
</script>

<style lang="scss" scoped>
.wrapper {
    width: 100vw;
    margin: 0 auto;
    // margin-top: 14vw;
    height: 100vh;
    // background-image: url("../../assets/modal/share.png");
    background-size: 100% 100%;
    overflow: hidden;
    text-align: right;
    .tip {
        width: 64.63vw;
        margin: 4vw;
    }
}

</style>